import { render, staticRenderFns } from "./Passport.vue?vue&type=template&id=6aeebdb8&scoped=true"
import script from "./Passport.vue?vue&type=script&lang=js"
export * from "./Passport.vue?vue&type=script&lang=js"
import style0 from "./Passport.vue?vue&type=style&index=0&id=6aeebdb8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aeebdb8",
  null
  
)

export default component.exports